import React, { useContext } from "react";
import { BsSkipBackwardCircleFill } from "react-icons/bs";
import { Link } from "react-router-dom";
import DashboardMain_Bus from "./../DashboardMain_Bus/DashboardMain_Bus";
import AppContext from "../../../store/AppContext";

function GlossaryPage_Charging_Bus() {
  const app_ctx = useContext(AppContext);
  return (
    <>
      <DashboardMain_Bus>
        <body style={{ backgroundColor: "white" }}>
          <h1
            style={{
              fontWeight: "bold",
              marginLeft: "2em",
              marginTop: "1em",
              fontSize: "2em",
            }}
            align="center"
          >
            Glossary Page
            <Link
              to="/dashboard_bus/charginganalysis_bus"
              style={{
                color: "rgb(131, 164, 207)",
                marginLeft: "5%",
                fontSize: "0.7em",
              }}
            >
              <BsSkipBackwardCircleFill />
            </Link>
          </h1>

          <table
            className="table table-hover tableglosary"
            style={{ width: "50%", height: "20%" }}
            align="center"
          >
            <thead
              style={{ backgroundColor: "rgb(131, 164, 207)", color: "#fff" }}
            >
              <tr>
                <th scope="col">Sr.No.</th>
                <th scope="col">KPI name</th>
                <th scope="col">Business Logics</th>
                <th scope="col">Backend Formula</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1</td>
                <td>Total Vehicle Count</td>
                <td>Count of total vehicle for selected date range</td>
                <td>Distinct Count (VIN)</td>
              </tr>
              <tr>
                <td>2</td>
                <td>Charged Vehicle Count</td>
                <td>
                  Count of vehicle who has done charging for selected date range
                </td>
                <td>Distinct Count (Charged VIN) </td>
              </tr>
              <tr>
                <td>3</td>
                <td>Total Charging Cycles</td>
                <td>
                  gunConnect & gunDisconnect event is called 1 charging cycle
                </td>
                <td>Count (gun_end)</td>
              </tr>
              <tr>
                <td>4</td>
                <td>Critical Faulty Cycles</td>
                <td>
                  Number of cycles who has received critical signals during a
                  gun cycle
                </td>
                <td>Count (signal_occurence_count)</td>
              </tr>
              <tr>
                <td>5</td>
                <td>Interruption Cycles</td>
                <td>
                  Number of cycles who has received interruptions in a gun cycle
                </td>
                <td>Count (NoOfInterrupt)</td>
              </tr>
              <tr>
                <td>6</td>
                <td>Opportunity Charged Cycles</td>
                <td>
                  Total number of Opportunity charging cycles where End SoC &lt;
                  100
                </td>
                <td>Count (charging Cycles where soc_end &lt;100)</td>
              </tr>
              <tr>
                <td>7</td>
                <td>Full Charged Cycles</td>
                <td>
                  Total number of Full charging cycles where End SoC = 100
                </td>
                <td>Count (charging Cycles where soc_end = 100)</td>
              </tr>
              <tr>
                <td>8</td>
                <td>Median gun duration (min)</td>
                <td>
                  Difference between Gun end time and Gun start time give us gun
                  duration
                </td>
                <td>Median (gunDurationInMin)</td>
              </tr>
              <tr>
                <td>9</td>
                <td>Median Charge duration (min)</td>
                <td>
                  Time between chargeStart & chargeEnd. There will be multiple
                  chargeStart & chargeEnd in 1 cycle (depending upon
                  interruptions). Summation of all the multiple charge events
                  should be taken for ChargeDuration
                </td>
                <td>Median (chargeDurationInMin)</td>
              </tr>
              <tr>
                <td>10</td>
                <td>Gun Connected after full charge (min)</td>
                <td>
                  Duration in which gun is connected after full charge of
                  battery.
                </td>
                <td>Median (gun_end - LastChargeTime)</td>
              </tr>
              <tr>
                <td>11</td>
                <td>Median Interruptions</td>
                <td>
                  Number of times charging has been stopped when gun is connect
                  during a cycle
                </td>
                <td>Median (NoOfInterrupt)</td>
              </tr>
              <tr>
                <td>12</td>
                <td>Interruption time (min)</td>
                <td>
                  Duration of charging has been stopped when gun is connect
                  during a cycle
                </td>
                <td>Median (InterruptDurationInMin)</td>
              </tr>
              <tr>
                <td>13</td>
                <td>KWH Charged/Cycle</td>
                <td>Median of Difference between start and end kWh</td>
                <td>
                  Median (A_KWh_Remain+B_KWh_Remain+C_KWh_Remain+D_KWh_Remain) @
                  gunStartTime -
                  (A_KWh_Remain+B_KWh_Remain+C_KWh_Remain+D_KWh_Remain) @
                  gunEndTime
                </td>
              </tr>
              <tr>
                <td>14</td>
                <td>ROC (%/hr)</td>
                <td>delta_soc/ChargeDur(in hours)</td>
                <td>Median [delta_soc/( chargeDurationInMin /60)]</td>
              </tr>
              <tr>
                <td>15</td>
                <td>Charging Current</td>
                <td>Charging Current between gun start and gun end</td>
                <td>average (ChargingCurrent[gunStartTime:gunEndTime])</td>
              </tr>
              <tr>
                <td>16</td>
                <td>SOC @ Charging Start</td>
                <td>SOC at the start of the gun cycle</td>
                <td>BatterySOC @ gunStartTime</td>
              </tr>
              <tr>
                <td>17</td>
                <td>SOC @ Charging End</td>
                <td>SOC at the end of the gun cycle</td>
                <td>BatterySOC @ gunEndTime</td>
              </tr>
              <tr>
                <td>18</td>
                <td>SOC Charged/Cycle</td>
                <td>Median of Difference between end and start Soc</td>
                <td>Median (End_SoC - Start_Soc)</td>
              </tr>
              <tr>
                <td>19</td>
                <td>Daily Charging Cycles/vehicle</td>
                <td>Median of charging cycles per day and vehicle</td>
                <td>Median of cycle count per day and vehicle</td>
              </tr>
              <tr>
                <td>20</td>
                <td>Daily Charging kwh/vehicle</td>
                <td>Median of kWh charged per day and vehicle</td>
                <td>Median (kwhCharged) per day and vehicle</td>
              </tr>
              <tr>
                <td>21</td>
                <td>Daily Charging Duration/vehicle</td>
                <td>Median of gun duration per day and vehicle</td>
                <td>Median (gunDurationInMin) per day and vehicle</td>
              </tr>
              <tr>
                <td>22</td>
                <td>A_Max_Cell_Temp</td>
                <td>Max of Max temp - Pack A temp( ̊C)</td>
                <td>max(A_Max_Cell_Temp[gunStartTime:gunEndTime])</td>
              </tr>
              <tr>
                <td>23</td>
                <td>B_Max_Cell_Temp</td>
                <td>Max of Max temp - Pack B temp( ̊C)</td>
                <td>max(B_Max_Cell_Temp[gunStartTime:gunEndTime])</td>
              </tr>
              <tr>
                <td>24</td>
                <td>C_Max_Cell_Temp</td>
                <td>Max of Max temp - Pack C temp( ̊C)</td>
                <td>max(C_Max_Cell_Temp[gunStartTime:gunEndTime])</td>
              </tr>
              <tr>
                <td>25</td>
                <td>D_Max_Cell_Temp</td>
                <td>Max of Max temp - Pack D temp( ̊C)</td>
                <td>max(D_Max_Cell_Temp[gunStartTime:gunEndTime])</td>
              </tr>
              <tr>
                <td>26</td>
                <td>A_Min_Cell_Volt</td>
                <td>Max of Min volt - Pack A (volts)</td>
                <td>max(A_Min_Cell_Volt[gunStartTime:gunEndTime])</td>
              </tr>
              <tr>
                <td>27</td>
                <td>B_Min_Cell_Volt</td>
                <td>Max of Min volt - Pack B (volts)</td>
                <td>max(B_Min_Cell_Volt[gunStartTime:gunEndTime])</td>
              </tr>
              <tr>
                <td>28</td>
                <td>C_Min_Cell_Volt</td>
                <td>Max of Min volt - Pack C (volts)</td>
                <td>max(C_Min_Cell_Volt[gunStartTime:gunEndTime])</td>
              </tr>
              <tr>
                <td>29</td>
                <td>D_Min_Cell_Volt</td>
                <td>Max of Min volt - Pack D (volts)</td>
                <td>max(D_Min_Cell_Volt[gunStartTime:gunEndTime])</td>
              </tr>
              <tr>
                <td>30</td>
                <td>A_Max_Cell_Volt</td>
                <td>Max of Max volt - Pack A (volts)</td>
                <td>max(A_Max_Cell_Volt[gunStartTime:gunEndTime])</td>
              </tr>
              <tr>
                <td>31</td>
                <td>B_Max_Cell_Volt</td>
                <td>Max of Max volt - Pack B (volts)</td>
                <td>max(B_Max_Cell_Volt[gunStartTime:gunEndTime])</td>
              </tr>
              <tr>
                <td>32</td>
                <td>C_Max_Cell_Volt</td>
                <td>Max of Max volt - Pack C (volts)</td>
                <td>max(C_Max_Cell_Volt[gunStartTime:gunEndTime])</td>
              </tr>
              <tr>
                <td>33</td>
                <td>D_Max_Cell_Volt</td>
                <td>Max of Max volt - Pack D (volts)</td>
                <td>max(D_Max_Cell_Volt[gunStartTime:gunEndTime])</td>
              </tr>
            </tbody>
          </table>
        </body>
      </DashboardMain_Bus>
    </>
  );
}

export default GlossaryPage_Charging_Bus;
